AUI().ready(
    'liferay-sign-in-modal',
    function (A) {
        var signIn = A.one('.sign-in > a');

        if (signIn && signIn.getData('redirect') !== 'true') {
            signIn.plug(Liferay.SignInModal);
        }
    }
);

/* Social share */

$('#sharebtn').on('click', function (e) {
    e.preventDefault();
    $('.taglib-social-bookmarks').toggleClass('is-visible');
    $('.rt-social-share-overlay').addClass('is-visible');
});

$('.rt-social-share-overlay').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.taglib-social-bookmarks').removeClass('is-visible');
    $(this).removeClass('is-visible');
});
